import {Navigate,useLocation} from 'react-router-dom';
export default function PricingAdminRedirect({section}:{section:'packs-history'|'packs-latest'}) {
 const {search}=useLocation();const params=new URLSearchParams(search);params.set('section',section);
 return <Navigate to={`/admin?${params}`} replace/>;
}
